import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// react-extension-root
const root = ReactDOM.createRoot(
  document.getElementById('react-extension-root') as HTMLElement
);
root.render(
  <App />
);
